import { render } from "./UnpaidPractice.vue?vue&type=template&id=464ab62b&scoped=true"
import script from "./UnpaidPractice.vue?vue&type=script&lang=js"
export * from "./UnpaidPractice.vue?vue&type=script&lang=js"

import "./UnpaidPractice.vue?vue&type=style&index=0&id=464ab62b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464ab62b"]])

export default __exports__